import React, { useState, useEffect } from 'react';
import { BsTrophy, BsLightbulb, BsConeStriped, BsBricks, BsShieldCheck, BsWrenchAdjustableCircle } from "react-icons/bs";
import axios from 'axios';


const WhyChooseUs = () => {
  const [whyChooseData, setwhyChoose] = useState({
    bestquality: '',
    integrity: '',
    strategy: '',
    safety: '',
    community: '',
    sustainability: '',
  });
  useEffect(() => {
      const fetchData = async () => {
      try {
          const res = await axios.get("/api/fetchwhychoose"); // Adjust port if needed
          const fetchedData = res.data[0]; // Assuming data is an array
          setwhyChoose({
              bestquality: fetchedData.bestquality || '',
              integrity: fetchedData.integrity || '',
              strategy: fetchedData.strategy || '',
              safety: fetchedData.safety || '',
              community: fetchedData.community || '',
              sustainability: fetchedData.sustainability || '',
          });
          //setWhatLooking(mapped);
      } catch (err) {
          console.error("Error fetching data:", err);
      }
      };
      fetchData();
  }, []);
    const whyChoose = [
      {
        id:1,
        icon:<BsTrophy />,
        heading:'Best Quality',
        content:whyChooseData.bestquality,
      },
      {
        id:2,
        icon:<BsLightbulb />,
        heading:'Integrity',
        content:whyChooseData.integrity,
      },
      {
        id:3,
        icon:<BsWrenchAdjustableCircle />,
        heading:'Strategy',
        content:whyChooseData.strategy,
      },
      {
        id:4,
        icon:<BsShieldCheck />,
        heading:'Safety',
        content:whyChooseData.safety,
      },
      {
        id:5,
        icon:<BsBricks />,
        heading:'Community',
        content:whyChooseData.community,
      },
      {
        id:6,
        icon:<BsConeStriped />,
        heading:'Sustainability',
        content:whyChooseData.sustainability,
      },
    ];

    return (
        <>
        <section className="why-choose-us relative py-12 bg-slate-400 bg-opacity-10">
          <div className="container mx-auto">
            <div className="flex text-center items-center justify-center w-full md:w-2/4 mx-auto mb-7">
              <div className="home-projects-head flex flex-col text-center items-center justify-center align-middle">
                  <h2 className="relative text-2xl leading-8 font-bold uppercase font-montserrat mb-2">
                  <span className="absolute top-1/2 -left-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                  <span className='text-slate-500 font-thin'>Why</span> Choose us
                  <span className="absolute top-1/2 -right-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                  </h2>
              </div>
            </div>
            <div className='flex md:flex-row flex-col'>
              <div className='w-full px-8 sm:px-0 py-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 grid-flow-row auto-rows-auto gap-8'>
                  {whyChoose.map((item,i)=>{ 
                  return (
                  <div className='flex flex-col justify-start items-center align-middle px-5 py-7 bg-white text-gray-600 text-base border-solid border-x border-y border-gray-200 rounded-xl box-shadow' key={item.id}>
                  <div className='text-3xl mb-5 text-orange-400'>{item.icon}</div>
                  <div className='text-xl font-semibold mb-4 text-gray-700'>{item.heading}</div>
                  <div className='text-center'>{item.content}</div>
                  </div>
                  )}
                )}
              </div>
            </div>
          </div>
        </section>
        </>
    );
}

export default WhyChooseUs;
